module.exports = __webpack_public_path__ + "img/iris-bonavida.ec44833a.jpg";